@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.CentralModal {
  // position in center of screen
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &:focus {
    outline: none;
  }
}

.CentralModalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5000;
  background: $color-container-shadow-A;
  padding: 1em;
}
